import React from 'react';
import { Button, Form, Input, Row, Col, Select, Checkbox } from 'antd';
const FormItem = Form.Item;
const Option = Select.Option;
import { observer, inject } from 'mobx-react';
import history from '@/lib/history';
import { formItemLayout } from '../../const/FormConst';

@inject('deviceGroupStore')
@observer
class SearchComponent extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentDidMount() {
    this.props.deviceGroupStore.loadDeviceGroup();
  }
  handleSubmit() {
    this.props.form.validateFields((error, value) => {
      if (!error) {
        this.props.deviceGroupStore.loadDeviceGroup(value.groupName);
      }
    });
  }
  componentWillUnmount() {
    this.props.form.resetFields();
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form onSubmit={this.handleSubmit}>
        <Row style={{ height: '40px' }}>
          <Col span={6} style={{ height: '40px' }}>
            <FormItem {...formItemLayout} label="分组名称">
              {getFieldDecorator('groupName')(
                <Input placeholder="请输入设备分组名称" />
              )}
            </FormItem>
          </Col>
          <Col span={2} offset={2}>
            <Button type="primary" onClick={this.handleSubmit}>
              搜索
            </Button>
          </Col>
          <Col span={2}>
            <Button
              type="primary"
              onClick={() => {
                history.push('/device/addGroup/group');
              }}
            >
              新建分组
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}
const DeviceGroupForm = Form.create()(SearchComponent);
export default DeviceGroupForm;



// WEBPACK FOOTER //
// ./src/components/DeviceGroup/DeviceGroupForm.js